import * as React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { useState } from 'react';
import EnrolmentPhotoCaptureEasyCrop from '../Utility/PhotoCapture';
import CloudUpload from '@material-ui/icons/CloudUpload'
import DeleteForever from '@material-ui/icons/DeleteForever'

interface Props {
    setPhoto: (photo) => void
    photo: File | undefined,
}

const EnrolmentPhotoCapture: React.FunctionComponent<Props> = ({ setPhoto, photo }) => {
    const theme = useTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down('sm'));


    const [dialogOpen, setDialogOpen] = useState(false);

    const toggleOpen = () => {
        setDialogOpen(!dialogOpen);
    }

    const clearPhoto = () => {
        toggleOpen();
        setPhoto(undefined);
    }

    const closeDialog = () => {
        toggleOpen();
        setPhoto(undefined);
    }

    return (
        <React.Fragment>
            {photo === undefined ?
                <React.Fragment>
                    <Button color="primary" variant="contained" onClick={toggleOpen} endIcon={<CloudUpload />} >Upload photo</Button>
                    <Dialog open={dialogOpen} fullScreen={fullscreen} fullWidth={true} maxWidth={"sm"}>
                        <EnrolmentPhotoCaptureEasyCrop setPhoto={setPhoto} closeDialog={closeDialog}/>
                    </Dialog>
                </React.Fragment>
                :
                <React.Fragment>
                    <Grid container justify="center" alignItems="center">
                        
                        <img src={URL.createObjectURL(photo)} style={{ height: '400px', width: '300px', borderWidth: '1px', borderColor: '#c1c1c1', borderStyle: 'solid', borderRadius: '4px' }} />
                    


                        <Grid item xs={12}>
                            <Button color="primary" variant="contained" onClick={clearPhoto} endIcon={<DeleteForever />}>Clear photo</Button>
                        </Grid>
                    </Grid>
                   
                </React.Fragment>
            }
        </React.Fragment >
    );
}

export default (EnrolmentPhotoCapture);